module.exports = {
  title: "Paul's Pet Projects", // Required
  author: 'Paul Harte', // Required
  description: 'Lead developer / Manager / Python lover / SQL nerd / AI & ML dabbler',
  primaryColor: '#facd48', // Required 
  showHeaderImage: true,
  showShareButtons: true,
  postsPerPage: 5, // Required
  social: {
    website: 'http://www.paulspetprojects.net',
    github: 'https://github.com/paulharte',
    twitter: 'https://twitter.com/paulspetproject',
    linkedin: 'https://www.linkedin.com/in/paul-harte-78032261/',
  },
  pathPrefix: '/devblog',
  siteUrl: 'https://www.paulspetprojects.net',
  siteMaxWidth: '1600px'
};
